import { Tabs, message } from "antd";
import React, { useContext, useEffect, useState } from "react";


import { api } from "../../services/api";
import { Page } from "./styles";
import { IClient } from "../Clients";
import { ThemeContext } from "styled-components";
import { QueueCompletedTable } from "../../components/QueueCompletedTable";
import { QueueFailedTable } from "../../components/QueueFailedTable";
import { QueueWaitingTable } from "../../components/QueueWaitingTable";
import { QueuePausedTable } from "../../components/QueuePausedTable";
import { Button } from "../../components/Button";
import { socket } from "../../services/socket";
import { QueueDelayeddTable } from "../../components/QueueDelayeddTable";


export type Data = {
  clientId: string;
  userId: string;
  message: string;
  number: string;
}
export type IQueue = {
  id: string;
  name: string;
  data: Data;
  progress: number;
  delay: number;
  timestamp: number;
  attemptsMade: number;
  failedReason: string;
  stacktrace: null[];
  returnvalue: null;
  finishedOn: number;
  processedOn: number;
}


const Queue = () => {
  const theme = useContext(ThemeContext);
  const [queueCount, setQueueCount] = useState({} as any)
  const [loadingBtn, setLoadingBtn] = useState(false)
  function fetchData() {
    api.get('/queue/count').then((response) => {
      setQueueCount(response.data)
    }).catch((err) => {
      message.error(err.response.data.message);
    })
  }
  function handlePauseQueue() {
    setLoadingBtn(true)
    api.post('/queue/pause').then(() => {
      message.success("Fila pausada");
    }).catch((err) => {
      message.error(err.response.data.message);
    }).finally(() => setLoadingBtn(false))
  }
  function handleCancelQueue() {
    setLoadingBtn(true)
    api.post('/queue/cancel').then(() => {
      message.success("Fila cancelada");
    }).catch((err) => {
      message.error(err.response.data.message);
    }).finally(() => setLoadingBtn(false))
  }
  function handleResumeQueue() {
    setLoadingBtn(true)
    api.post('/queue/resume').then(() => {
      message.success("Fila resumida");
    }).catch((err) => {
      message.error(err.response.data.message);
    }).finally(() => setLoadingBtn(false))
  }

  useEffect(fetchData, [])
  useEffect(() => {
    socket.on("queue-resume", () => {
      fetchData();
    });
    socket.on("queue-paused", () => {
      fetchData();
    });
    socket.on("queue-canceled", () => {
      fetchData();
    });
  }, [])
  return (

    <Page>
      <header>
        <span>Disparo de mensagem</span>
      </header>
      <div className="content">
        <div className="header-conf">
          <span>
            Gerenciamento de fila
          </span>
        </div>
        <div className="control">
          <Button title="Pausar" loading={loadingBtn} onClick={handlePauseQueue} />
          <Button title="Continuar" loading={loadingBtn} onClick={handleResumeQueue} />
          <Button title="Cancelar" loading={loadingBtn} onClick={handleCancelQueue} />
        </div>
      </div >
      <div className="content">
        <Tabs
          defaultActiveKey="1"
          style={{
            color: theme.colors.secondary100,
            fontWeight: 'bold'
          }}
        >
          <Tabs.TabPane tab={`ENVIANDO (${queueCount?.waiting || '0'})`} key="1">
            <QueueWaitingTable total={queueCount?.waiting} />
          </Tabs.TabPane>
          <Tabs.TabPane tab={`ENVIADAS (${queueCount?.completed || '0'})`} key="2">
            <QueueCompletedTable total={queueCount?.completed} />
          </Tabs.TabPane>
          <Tabs.TabPane tab={`FALHAS (${queueCount?.failed || '0'})`} key="3">
            <QueueFailedTable total={queueCount?.failed} />
          </Tabs.TabPane>
          <Tabs.TabPane tab={`PAUSADAS (${queueCount?.paused || '0'})`} key="4">
            <QueuePausedTable total={queueCount?.paused} />
          </Tabs.TabPane>
          <Tabs.TabPane tab={`ATRASADAS (${queueCount?.delayed || '0'})`} key="5">
            <QueueDelayeddTable total={queueCount?.delayed} />
          </Tabs.TabPane>
        </Tabs >


      </div >
    </Page >

  );
};
export { Queue };
